'use strict';

import appModule from '../app.module';

/**
 * NotificationService — détecte les nouvelles publications et actualités
 * depuis la dernière visite de l'utilisateur (stockée en localStorage).
 */
angular.module(appModule).service('NotificationService', ['$http', '$q', function($http, $q) {

  var STORAGE_KEY = 'otfip_last_visit';

  // ── Helpers date ─────────────────────────────────────────────────────────

  function getLastVisit() {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return new Date(stored);
    }
    // Première visite : montrer les 30 derniers jours
    var d = new Date();
    d.setDate(d.getDate() - 30);
    return d;
  }

  function setLastVisit() {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
  }

  function parseDate(val) {
    if (!val) return null;
    // Spring Boot peut sérialiser LocalDateTime en tableau [year,month,day,h,m,s,nano]
    if (Array.isArray(val)) {
      return new Date(val[0], val[1] - 1, val[2], val[3] || 0, val[4] || 0, val[5] || 0);
    }
    return new Date(val);
  }

  function isNew(dateVal, lastVisit) {
    var d = parseDate(dateVal);
    if (!d || isNaN(d.getTime())) return false;
    return d > lastVisit;
  }

  // ── API publique ──────────────────────────────────────────────────────────

  this.getNotifications = function() {
    var lastVisit  = getLastVisit();
    var deferred   = $q.defer();
    var items      = [];

    var pubsP = $http.get('/api/publications/recent?size=8')
      .then(function(res) {
        (res.data || []).forEach(function(p) {
          if (isNew(p.publicationDate || p.createdAt, lastVisit)) {
            items.push({
              id:     'pub-' + p.id,
              type:   'publication',
              icon:   'fa-file-text-o',
              color:  '#0147a3',
              label:  'Publication',
              titre:  p.title,
              date:   parseDate(p.publicationDate || p.createdAt),
              state:  'main.publications'
            });
          }
        });
      })
      .catch(angular.noop);

    var actusP = $http.get('/api/actualites?page=0&size=8')
      .then(function(res) {
        var list = (res.data && res.data.content) ? res.data.content : (res.data || []);
        list.forEach(function(a) {
          if (isNew(a.publishedAt || a.createdAt, lastVisit)) {
            items.push({
              id:     'actu-' + a.id,
              type:   'actualite',
              icon:   'fa-newspaper-o',
              color:  '#059669',
              label:  'Actualité',
              titre:  a.titre,
              date:   parseDate(a.publishedAt || a.createdAt),
              state:  'main.actualites'
            });
          }
        });
      })
      .catch(angular.noop);

    $q.all([pubsP, actusP]).then(function() {
      items.sort(function(a, b) { return (b.date || 0) - (a.date || 0); });
      deferred.resolve(items);
    });

    return deferred.promise;
  };

  this.markAllRead = function() {
    setLastVisit();
  };

  this.getLastVisit = getLastVisit;
}]);
